export enum SavedSearchTypeEnum {
  advancedSearchExactSku,
  advancedSearchUseRecommended
}
